import { PinInput as MantinePinInput, PinInputProps } from '@mantine/core';

export type IPinInputProps = PinInputProps;

/** @registry Design-layer pass-through over Mantine PinInput; import this instead of @mantine/core PinInput outside src/design. Extend here when PinInput needs house behavior. */
export const PinInput = MantinePinInput;
